import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';

@Injectable()
export class PrintService {
  isPrinting = false;

  constructor(private router: Router) { }

  printDocument() {
    this.isPrinting = true;
    setTimeout(() => {
      window.print();
      
      this.isPrinting = false;
      //this.router.navigate([{ outlets: { print: null }}]);
      
    });
    // this.router.navigate(['/', 
    // { outlets: { 
    //   'print' : ['print']
    //   // 'print' : ['print','summarystage']
    // }}]);
  }

  onDataReady() {
    setTimeout(() => {
      window.print();
      
      this.isPrinting = false;
      this.router.navigate([{ outlets: { print: null }}]);
      
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/print.service.ts